<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    outlined
    placeholder=" "
  />
</template>

<script>
const AdsTextField = {
  name: "AdsTextField",
};

export default AdsTextField;
</script>

<style lang="scss" scoped>
@import '../../styles/ads.scss';

.v-application .error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep div.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep label.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep button.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}

::v-deep i.error--text {
  color: $ads-error-red !important;
  caret-color: $ads-error-red !important;
}
</style>
